<template>
	<div>
		<el-dialog title="分配线索" class="allocation" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
			<div class="title">请选择要分配的员工</div>
			<div class="mb-16 flex">
				<el-input class="mr-16" v-model="partner_role_name" clearable placeholder="请输入员工名称" />
				<el-button type="primary" @click="getPartnerList">搜索</el-button>
			</div>
			<el-table :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
				<el-table-column min-width="40">
					<template v-slot="{ row }">
						<el-radio v-model="user_id" :label="row.user_id">{{ '' }}</el-radio>
					</template>
				</el-table-column>
				<el-table-column label="员工名称" min-width="170">
					<template v-slot="{ row }">
						<div class="flex flex-align-center">
							<yx-avatar size="small" :src="row.avatar_url"></yx-avatar>
							<p class="ml-6">{{ row['partner_name'] }}</p>
							<el-tag v-if="row.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
							<el-tag class="ml-8" v-else-if="row.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="mobile" label="手机号" min-width="150"></el-table-column>
				<el-table-column prop="anchor_count" label="当前跟进达人数" min-width="140"></el-table-column>
			</el-table>
			<yx-pagination
				:total="total"
				:current-page="pageInfo.page_index"
				:page-size="pageInfo.page_size"
				@size-change="sizeChange"
				@current-change="currentChange"
			/>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit">确认分配</el-button>
			</span>
		</el-dialog>
		<singleChecksphDialog ref="singleChecksphDialog" @confirm="confirmCheck" />
	</div>
</template>

<script>
import { getPartnerList, allotTalent, sphCheckAddVideo } from '@/api/talentCRM';
import singleChecksphDialog from '../singleChecksphDialog';
export default {
	name: 'allocationDialog',
	components: {
		singleChecksphDialog,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: '',
		},
	},
	data() {
		return {
			dialogVisible: false,
			user_id: 0,
			partner_role_name: '',
			list: [],
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			row: {},
			videoNo: '',
		};
	},
	methods: {
		show(row) {
			this.row = row;
			this.getPartnerList();
			this.dialogVisible = true;
		},
		handleClose() {
			this.anchor_id = this.user_id = 0;
			this.partner_role_name = '';
			this.videoNo = '';
			this.dialogVisible = false;
		},
		async getPartnerList() {
			const { partner_role_name } = this;
			const { code, data: { list = [], page = {} } = {} } = await getPartnerList({
				// role_id: drRoleType.id,
				partnerName: partner_role_name,
				...this.pageInfo,
			});
			if (code !== 0) return;
			this.list = list;
			this.total = page.item_total;
			this.user_id = 0;
		},
		sizeChange(size) {
			this.pageInfo.page_size = size;
			this.getPartnerList();
		},
		currentChange(index) {
			this.pageInfo.page_index = index;
			this.getPartnerList();
		},
		confirmCheck(row, videoNo = '') {
			this.videoNo = videoNo;
		},
		async submit() {
			const { user_id, videoNo } = this;
			const { anchor_id } = this.row;
			if (this.$isSp() && !videoNo) {
				const { need_videono = false } = await sphCheckAddVideo({ anchorId: anchor_id });
				if (need_videono) return this.$refs.singleChecksphDialog.show(this.row, 'distribution');
			}
			if (!user_id) return this.$message.error('请选择要分配的员工');
			const { code } = await allotTalent({ anchor_id, user_id, videoNo });
			if (code !== 0) return;
			this.$message.success('分配成功');
			this.$emit('getList');
			this.handleClose();
		},
	},
};
</script>

<style lang="less" scoped>
.title {
	font-size: 14px;
	color: #1d1f23;
	margin-bottom: 12px;
}
/deep/ .el-radio {
	margin-left: 6px;
}
/deep/ .el-radio .el-radio__label {
	display: inherit;
}
/deep/ .el-table__body-wrapper {
	height: 300px;
	overflow-y: auto;
}

.allocation {
	/deep/ .el-dialog__body {
		padding-bottom: 0px !important;
	}
	/deep/ .el-dialog__footer {
		padding-top: 0px;
	}
}
</style>
